import { render, staticRenderFns } from "./CompanyToolbarBranding.vue?vue&type=template&id=3f0bac09&scoped=true&"
import script from "./CompanyToolbarBranding.vue?vue&type=script&lang=js&"
export * from "./CompanyToolbarBranding.vue?vue&type=script&lang=js&"
import style0 from "./CompanyToolbarBranding.vue?vue&type=style&index=0&id=3f0bac09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bac09",
  null
  
)

export default component.exports